import ImageUpload from './ImageUpload'
import enhance from './ImageUpload.enhancer'

export default enhance(ImageUpload)



// WEBPACK FOOTER //
// ./src/components/organisms/ImageUpload/index.js